import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "49.976",
  width: "50",
  viewBox: "-54.5 413.8 50 49.976",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#2c6899",
    d: "M-29.998 413.8c-2.1 0-3.987.21-5.666.42-5.037.84-6.086 2.728-6.086 6.296v4.617h11.962v1.47h-16.37c-3.567 0-6.505 2.097-7.554 6.085-1.05 4.617-1.05 7.345 0 12.172.84 3.567 2.938 6.086 6.296 6.086h4.197v-5.457c0-3.99 3.36-7.35 7.56-7.35h11.96c3.36 0 6.09-2.73 6.09-6.09v-11.33c0-3.15-2.73-5.668-6.084-6.298-2.1-.42-4.2-.63-6.3-.63zm-6.506 3.568c1.26 0 2.31 1.05 2.31 2.308s-1.05 2.31-2.31 2.31-2.308-1.05-2.308-2.31c.21-1.26 1.26-2.308 2.308-2.308z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#ffcf3f",
    d: "M-16.147 426.6v5.247c0 4.197-3.568 7.555-7.555 7.555h-11.962c-3.358 0-6.086 2.728-6.086 6.086v11.333c0 3.15 2.728 5.25 6.086 6.09 3.777 1.05 7.345 1.26 11.962 0 2.938-.84 6.086-2.73 6.086-6.08v-4.615h-11.962v-1.47h18.048c3.568 0 4.827-2.52 6.086-6.085 1.26-3.78 1.26-7.346 0-12.173-.84-3.567-2.518-6.085-6.086-6.085h-4.617zm-6.716 28.96c1.26 0 2.31 1.05 2.31 2.31s-1.05 2.308-2.31 2.308-2.308-1.05-2.308-2.308c0-1.47 1.04-2.31 2.3-2.31z"
  })]
});